import { EventEmitter, Injectable } from '@angular/core';
import { DraggableModalOptions } from '../draggable-modal.service';

@Injectable()
export class TrayService {
  modals = [];
  updateTray = new EventEmitter();
  maximizeModal = new EventEmitter();
  constructor() {
    this.modals = localStorage.getItem('bs-draggable-modals-tray') ? JSON.parse(localStorage.getItem('bs-draggable-modals-tray')) : [];
    if (this.modals.length) {
      this.updateTray.emit(this.modals);
    }
  }

  addModalToTray(modal: DraggableModalOptions) {
    if (!this.findModal(modal.id)) {
      this.modals.push(modal);
      this.updateTray.emit(this.modals);
    }
  }

  updateModal(options: DraggableModalOptions) {
    const index = this.modals.map(modal => modal.id).indexOf(options.id);
    if (index !== -1) {
      this.modals[index] = Object.assign(this.modals[index], options);
      this.updateTray.emit(this.modals);
    }
  }

  removeModalFromTray(id: string) {
    const index = this.modals.map(modal => modal.id).indexOf(id);
    this.modals.splice(index, 1);
    this.updateTray.emit(this.modals);
  }

  findModal(id: string) {
    return this.modals.find(modal => modal.id === id);
  }

  removeAllModals() {
    this.modals = [];
    this.updateTray.emit(this.modals);
  }


}
